import { Component, Input, OnInit } from '@angular/core';
import { DealService } from '../../shared/services/deal.service';
import { FilterService } from '../../shared/services/filter.service';
import { DealFilterService } from '../../shared/services/deal.filter.service';
import { DealsData } from '../../shared/models/dealsdata.model';
import { FilterConfig } from '../../shared/models/filterconfig.model';
import { Deal } from '../../shared/models/deal.model';
import { FilterUrlService } from '../../shared/services/filter.url.service';
import { Filter } from '../../shared/models/filter.model';
import { FilterCountService } from '../../shared/services/filter.count.service';
import { ItemService } from '../../shared/services/item.service';
import { ItemFilterService } from '../../shared/services/item.filter.service';
import { MobileMenuComponent } from '../mobileMenu/mobilemenu.component';
import { ResetFormComponent } from '../resetForm/reset.form.component';
import { FilterContainerComponent } from '../filterContainer/filter.container.component';
import { ResultsSummaryComponent } from '../resultsSummary/results.summary.component';
import { TileContainerComponent } from '../tileContainer/tile.container.component';

/**
 * This class represents the lazy loaded PageComponent.
 */
@Component({
  selector: 'app-deals',
  templateUrl: 'deals.component.html',
  providers: [
    FilterCountService,
    FilterService,
    FilterUrlService,
    DealFilterService,
    DealService,
    { provide: ItemService, useExisting: DealService },
    { provide: ItemFilterService, useExisting: DealFilterService },
  ],
  imports: [
    MobileMenuComponent,
    ResetFormComponent,
    FilterContainerComponent,
    ResultsSummaryComponent,
    TileContainerComponent,
  ],
})
export class DealsComponent implements OnInit {
  @Input() dealsData: DealsData = new DealsData();

  constructor(
    private filterService: FilterService,
    private _filterUrlService: FilterUrlService,
    private dealService: DealService,
    private dealFilterService: DealFilterService,
  ) {}

  get deals$() {
    return this.dealFilterService.filteredItems$;
  }

  get filters$() {
    return this.filterService.currentFilter$;
  }

  filterUpdated(newFilters: Filter[]): void {
    this.filterService.updateFilter(newFilters);
  }

  onResetFilter(): void {
    this.filterService.initializeCurrentFilter(false);
  }

  /**
   * Set datalist to the property in the Service
   * @param datalist
   */
  setDealsData(datalist: Deal[]) {
    this.dealService.items = datalist;
  }

  /**
   * Set filterlist to the filterService service
   * @param filterlist
   */
  setFiltersData(filterlist: FilterConfig[]) {
    this.filterService.filterConfigs = filterlist;
    this.filterService.initializeCurrentFilter(true);
  }

  ngOnInit() {
    this.setDealsData(this.dealsData.results ?? []);
    this.setFiltersData(this.dealsData.filters ?? []);
  }
}
